// src/auth/msalInstance.js
import { PublicClientApplication, LogLevel } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

const configWithLogger = {
  ...msalConfig,
  system: {
    loggerOptions: {
      logLevel: LogLevel.Verbose,
      loggerCallback: (_level, message, containsPii) => {
        if (!containsPii) console.log("[MSAL]", message);
      },
    },
  },
};

export const msalInstance = new PublicClientApplication(configWithLogger);
